/**
 * Testing this hook directly has proven more trouble than it's worth for
 * minimal benefit, due to the need for an apollo provider setup and mock
 * components for testing hooks. Instead the code is covered by tests for the
 * AvailabilityStep component where it's used where it's used
 */

import { ActionType } from "../../../AppDataProvider/actions";
import { AppContext } from "../../../AppDataProvider/AppDataProvider";
import { useContext } from "react";
import { useDeleteReservedSpaceMutation } from "../../../GeneratedGraphQL";

export type UseDeleteExistingReservedSpaceOptions = {
  organisationId: string;
  reservedSpaceId?: string;
};

export function useDeleteExistingReservedSpace({
  organisationId,
  reservedSpaceId,
}: UseDeleteExistingReservedSpaceOptions) {
  const [deleteReservedSpace] = useDeleteReservedSpaceMutation({
    errorPolicy: "all",
  });
  const { appDataDispatch } = useContext(AppContext);

  /**
   * We want this hook to always return an async function, so that we can choose
   * to await reserved space deletion or not. But if there's no reservedSpaceId,
   * we don't want that function to actually do anything, because there's no
   * reserved space to delete.
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  if (!reservedSpaceId) return async function doNothing() {};

  return async function deleteExistingReservedSpace() {
    await deleteReservedSpace({
      variables: { organisationId, reservedSpaceId },
    })
      .then((response) => {
        if (response.errors?.length) throw response.errors[0];
        if (response.data?.deleteReservedSpace) {
          appDataDispatch({ type: ActionType.RESERVED_SPACE_DELETED });
        }
      })
      .catch((error: Error) => console.error(error.message));
  };
}
